import {
  CHANGE_SIDEBAR_VISIBILITY,
  CHANGE_MOBILE_SIDEBAR_VISIBILITY,
  CHANGE_USER_VIEW_AS,
} from '../actions/sidebarActions';

const user = JSON.parse(localStorage.getItem('currentUser')) || {};
const viewPageAs = Number(localStorage.getItem('viewPageAs') || '0');
let defaultView = 0;
if (user.esAlumno) {
  defaultView = 0;
} else if (user.esProfesor) {
  defaultView = 1;
} else if (user.esFuncionario) {
  defaultView = 2;
} else if (user.esFuncionario) {
  defaultView = 3;
}

// Se lee el estado de 'collapse' desde localStorage
const sidebarCollapse = JSON.parse(localStorage.getItem('sidebarCollapse')) || false;

const initialState = {
  show: false,
  collapse: sidebarCollapse,
  viewPageAs: user.isAuthenticated ? viewPageAs || defaultView : defaultView,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIDEBAR_VISIBILITY: {
      const newCollapseState = !state.collapse;
      localStorage.setItem('sidebarCollapse', newCollapseState);
      return { ...state, collapse: newCollapseState };
    }
    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show };
    case CHANGE_USER_VIEW_AS:
      localStorage.setItem('viewPageAs', action.value);
      return { ...state, viewPageAs: action.value };
    default:
      return state;
  }
}
